import { useCallback, useMemo } from 'react'
import { GraphQL } from '@guestgoodie/graphql'
import { reccurences, RRule, rrulestr } from '@guestgoodie/helpers'

import { RecDate } from './RecDate'
import { RRuleInput } from './RRuleInputs'

interface Props {
  value: GraphQL.RecurrenceFragmentFragment
  onChange: (newRecurrence: GraphQL.RecurrenceFragmentFragment) => void
  showUntil?: boolean
}

export function RecurrenceInput(props: Props) {
  const { value, onChange, showUntil = true } = props

  const startDate = useMemo(() => new Date(value.startDate), [value.startDate])
  const duration = useMemo(() => value.duration, [value.duration])
  const rrule = useMemo(() => rrulestr(value.rrule), [value.rrule])

  const onChangeStartDate = useCallback(
    (startDate: Date, duration: number) => {
      const [hours, minutes] = startDate.toISOString().split('T')[1].split(':')

      const newRule = new RRule({
        ...rrule.origOptions,
        byhour: parseInt(hours),
        byminute: parseInt(minutes),
        bysecond: null,
        dtstart: null
      })

      const newRRule = reccurences.rruleToApiReadyString(newRule)

      onChange({ ...value, rrule: newRRule, startDate, duration })
    },
    [value, rrule, onChange]
  )

  const onChangeRRule = useCallback(
    (rrule: RRule) => {
      const newRRule = reccurences.rruleToApiReadyString(rrule)

      onChange({ ...value, rrule: newRRule })
    },
    [value, onChange]
  )

  return (
    <div className="flex flex-col gap-4">
      <RRuleInput rrule={rrule} onChange={onChangeRRule} />
      <RecDate
        startDate={startDate}
        duration={duration}
        isRecurring={rrule.options.count !== 1}
        showUntil={showUntil}
        onChange={onChangeStartDate}
      />
    </div>
  )
}
